<section class="container mobiledb-Container waitlist-container">
  <div class="row m-0 p-0">
    <div class="col-md-7">&nbsp;</div>
    <aside id="waitlist-aside2" class="col-md-5">

      <div class="row justify-content-end">
        <div class="col-md-6 dshbrd"><a (click)="gotoDashboard()"><span class="greenbottom"><img
        src="/icons/{{baseSiteId}}/chevron-left_2.svg" width="14">&nbsp;Back to dashboard</span></a>
      </div>
      <div class="dshbrdXLPrnt"><a (click)="downloadfile()"><span class="greenbottom"><img width="14"
      src="/icons/{{baseSiteId}}/excel_new.png">&nbsp;XLS</span></a>
    </div>
    <div class="col-md-3 dshbrdXLPrnt"><a (click)="printFunc()"><span class="greenbottom"><img
    src="/icons/{{baseSiteId}}/print.svg" width="16">&nbsp;Print</span></a></div>
  </div>


</aside>
</div>
<div class="row space-evenly">




  <div class="col-md-8" style="margin-right:-3px;">
    <div class="row">
      <div class="col-md-12 leftPanel m-0 p-0">

        <div class="container m-0 p-0">
          <p class="introtext" [innerHTML]="dataRes?.message"></p>
          @for (itm of dataRes?.seasonOrders; track itm) {
            <div>
              @if (itm?.waitlistOrders.length>0) {
                <div class="prodBlock">
                  <span class="formulaTitle">{{itm?.code}} formula</span>
                  <div class="row">
                    <div class="col-md-12 bottomline"></div>
                  </div>
                  @for (itm2 of itm?.waitlistOrders; track itm2) {
                    <div>
                      <div class="row GBrow m-0 p-0">
                        <div class="col-12 col-md-8">
                          <div class="row">
                            <div class="col-md-3 img-product">
                              <img src="{{itm2.product?.thumbNailImg}}" height="50px" class="imgThumbnail">
                            </div>
                            <div class="col-md-9 productName" (click)="productDetails(itm2?.product)"
                              [innerHTML]="itm2?.product.variantProductDescription">
                            </div>
                          </div>
                          @if (itm2?.product?.ndcCode) {
                            <p class="ndcCode">
                            {{itm2?.product?.ndcCode}}</p>
                          }
                          <div class="row">
                            <div class="col product-code">{{itm2?.product?.code}} | {{itm2?.product?.manufacturer}}
                            </div>
                          </div>
                          @if (itm2?.product?.innerText && itm2?.product?.innerText !== '') {
                            <p class="inner-text">
                              <span [innerHtml]="itm2?.product?.innerText"></span>
                            </p>
                          }
                        </div>
                        @if (isGovtCustomer && isGovtLocationSelected && !itm2?.conditions) {
                          <div class="col-12 col-md-4"
                            >
                            <div class="row prod-no-contract">Product not on<br /> contract</div>
                          </div>
                        } @else {
                          <div class="col-12 col-md-4">
                            <div class="row">
                              <div class="col-12 p-0 unitareadosesAlign">
                                <p class="dosestext p-0">Units</p>
                                <section class="unit-area mb-1" id="unitArea">
                                  <span class="disabled " aria-hidden="true" class="no-print"
                                    id="{{'minusIcon'+itm2?.product.code}}">
                                    @if (itm2.status!='EXPORTED' && itm2?.quantity>0) {
                                      <img
                                        (click)="performQuantityComputation(itm2?.product.code,itm2?.quantity,'less',itm2.status)"
                                        src="/icons/{{baseSiteId}}/less.svg" id="{{'unitMinus'+itm2?.product.code}}"
                                        alt="">
                                    }
                                    @if (itm2.status=='EXPORTED') {
                                      <img src="/icons/less-disable.svg"
                                        id="{{'unitMinusDisable'+itm2?.product.code}}" alt="">
                                    }
                                    @if (itm2.status!='EXPORTED' && itm2?.quantity<1) {
                                      <img
                                        src="/icons/less-disable.svg"
                                        id="{{'unitMinusDisable'+itm2?.product.code}}" alt="">
                                    }
                                  </span>
                                  <input type="number" class="prod-quantity text-center" value={{itm2?.quantity}}
                                    (keyup)="performQuantityComputation2(itm2?.product.code,itm2?.quantity,'keyup')"
                                    id="{{'prodQuantity'+itm2?.product?.code}}" min="1" max="9999"
                                    onkeypress="return /[0-9a-zA-Z]/i.test(event.key)"
                                    onkeydown="javascript: return event.keyCode == 69 ? false : true"
                                    [disabled]="itm2.status=='EXPORTED'" appNoMouseScroll />
                                  <span class="" aria-hidden="true" class="no-print" id="{{'plusIcon'+itm2?.product.code}}">
                                    @if (itm2.status!='EXPORTED') {
                                      <img
                                        (click)="performQuantityComputation(itm2?.product.code,itm2?.quantity,'add',itm2.status)"
                                        src="/icons/{{baseSiteId}}/more.svg" id="{{'unitPlus'+itm2?.product.code}}"
                                        alt="">
                                    }
                                    @if (itm2.status=='EXPORTED') {
                                      <img src="/icons/more-disable.svg"
                                        id="{{'unitPlusDisable'+itm2?.product.code}}" alt="">
                                    }
                                  </span>
                                </section>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 p-0 unitareadosesAlign">
                                <p class="dosestext mb-0">{{itm2?.TotalitemQty}} doses</p>
                                @if (itm2.status!='EXPORTED') {
                                  <p class="waitlistLabel">Waitlist</p>
                                }
                                @if (itm2.status=='EXPORTED') {
                                  <p class="waitlistLabel">Waitlist Under Review</p>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      <div class="row">
                        <div class="col-md-12 bottomline"></div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }

        </div>

      </div>
    </div>
  </div>

  <aside id="waitlist-aside" style="background-color: #FFF;" class="col-md-4">
    <form class="contact-form" id="#waitlistrightsection" [formGroup]="contactForm">
      <section class="d-flex flex-column" style="margin-top:30px;">
        @if ((!POnameEdited && !ContactnameEdited && !editDeliveryHrs && !inValid) || faxNumberError) {
          <button tabindex="0" disabled
            id="SaveBtn"
          class="btn-primary" (click)="saveAllData()">Save Changes</button>
        }

        @if ((ContactnameEdited || POnameEdited || editDeliveryHrs) && !faxNumberError) {
          <button tabindex="0"
          id="SaveBtn" class="btn-primary" (click)="saveAllData()">Save Changes</button>
        }
        <button class="btn-secondary" (click)="closeEdit()">Undo Changes</button>
      </section>
      <section class="basic-details-section">
        <div class="d-flex flex-row justify-content-between">
          <h3>Details</h3>
          @if (!editPo) {
            <a href="javascript:void(0)" (click)="editPO()"
              style="background: url('/icons/{{baseSiteId}}/editIcon.png') 0 0/17px no-repeat padding-box"
            class="edit-icon">Edit</a>
          }
        </div>
        <div class="basic-details">
          <div class="basic-details__shipTo detailAddress">
            <label for="shipTo" class="shipTo">Ship To</label>
            <ul [ngStyle]="{'list-style': 'none', 'padding': '0'}">
              <li>{{dataRes?.shippingAddress?.companyName}} ({{dataRes?.shippingAddress?.accountNumber}})</li>
              <li>{{dataRes?.shippingAddress?.line1}}</li>
              <li>{{dataRes?.shippingAddress?.town}}, {{dataRes?.shippingAddress?.id}}
              {{dataRes?.shippingAddress?.poPostalCode}}</li>
            </ul>
          </div>
          <div class="basic-details__po">
            <label for="po" class="shipTo">PO#</label>
            @if (!editPo) {
              <span>{{dataRes?.poNumber}}</span>
            }
            @if (editPo) {
              <input type="text" (keyup)="changePOname()" [(ngModel)]="dataRes.poNumber"
                formControlName="poName">
            }
          </div>
        </div>
      </section>
      <section class="contact-section">
        <div class="d-flex flex-row justify-content-between">
          <h3>Contact</h3>
          @if (!editContact) {
            <a (click)="editContactmethod()"
              style="background: url('/icons/{{baseSiteId}}/editIcon.png') 0 0/17px no-repeat padding-box"
            class="edit-icon">Edit</a>
          }
        </div>
        <p>This is who we'll contact for updates on waitlisted items</p>

        <div class="formFields row">
          <label class="formLabel col-sm-4" for="contactName">Name</label>
          @if (!editContact) {
            <span class="readonly formlabelValue col-sm-8">{{dataRes?.contactName}}</span>
          }
          @if (editContact) {
            <div class="w-100 namealign">
              @if (editContact) {
                <input type="text" formControlName="name" id="contactName"
                  [(ngModel)]="dataRes.contactName" (keyup)="changeContactname()"
                  onkeydown="return /[a-z\s'-]/i.test(event.key)" class="formElement">
                }
              </div>
            }

          </div>
          @if (!editContact) {
            <div class="formFields row">
              <!-- use the label & span to display 'email' or 'fax' conditionaly -->
              @if (dataRes?.emailSelected) {
                <label class="formLabel col-sm-4" for="contactEmail">Email</label>
              }
              @if (!dataRes?.emailSelected && dataRes?.contactFax) {
                <label class="formLabel col-sm-4">Fax</label>
              }
              @if (!dataRes?.emailSelected && !dataRes?.contactFax) {
                <label class="formLabel col-sm-4">Email</label>
              }
              @if (dataRes?.emailSelected) {
                <span class="readonly formlabelValue col-sm-8"
                >{{dataRes?.contactEmail}}</span>
              }
              @if (!dataRes?.emailSelected && dataRes?.contactFax) {
                <span class="readonly formlabelValue col-sm-8"
                >{{dataRes?.contactFax}}</span>
              }
              @if (!dataRes?.emailSelected && !dataRes?.contactFax) {
                <span class="readonly formlabelValue col-sm-8"
                >{{dataRes?.contactEmail}}</span>
              }
            </div>
          }
          @if (editContact) {
            <div>
              <h4 class="contactmethod">Prefered contact method</h4>
              <div>
                <label class="formLabel">Email</label>
                <div class="row rowBtmCls">
                  <div class="col-sm-2 cotact-radio alignright">
                    @if (dataRes?.emailSelected) {
                      <input type="radio" id="orderConfirmationYesRadio" name="orderConfirmation" value="email"
                        checked (click)="contactmethodValchk($event)" />
                    }
                    @if (!dataRes?.emailSelected) {
                      <input type="radio" id="orderConfirmationYesRadio" name="orderConfirmation" value="email"
                        (click)="contactmethodValchk($event)" />
                    }
                  </div>
                  <div class="col-sm-10 cotact-input">
                    @if (!dataRes?.disableFax && !dataRes?.emailSelected && contactmethod) {
                      <ng-select
                        [readonly]="contactmethod" [searchable]="false" [clearable]="false"
                        (change)="getEmailDrpDwnVal($event)" bindLabel="name" [(ngModel)]="dataRes.contactEmail"
                        bindValue="isocode" placeholder="Please select" formControlName="email"
                        class="dropdown-credit disabled" (click)="changeColor()">
                        <ng-option disabled>Select Email Address</ng-option>
                        @for (itm of dataRes?.arrForEmailRightSide; track itm) {
                          <ng-option [value]="itm">{{itm}}</ng-option>
                        }
                        <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                      </ng-select>
                    }
                    @if (!dataRes?.disableFax && !dataRes?.emailSelected && !contactmethod) {
                      <ng-select
                        [searchable]="false" [clearable]="false" (change)="getEmailDrpDwnVal($event)" bindLabel="name"
                        [(ngModel)]="dataRes.contactEmail" bindValue="isocode" placeholder="Please select"
                        formControlName="email" class="dropdown-credit" (click)="changeColor()">
                        <ng-option disabled>Select Email Address</ng-option>
                        @for (itm of dataRes?.arrForEmailRightSide; track itm) {
                          <ng-option [value]="itm">{{itm}}</ng-option>
                        }
                        <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                      </ng-select>
                    }
                    @if (!dataRes?.disableFax && dataRes?.emailSelected) {
                      <ng-select [searchable]="false"
                        [clearable]="false" (change)="getEmailDrpDwnVal($event)" bindLabel="name"
                        [(ngModel)]="dataRes.contactEmail" bindValue="isocode" placeholder="Please select"
                        formControlName="email" class="dropdown-credit" (click)="changeColor()">
                        <ng-option disabled>Select Email Address</ng-option>
                        @for (itm of dataRes?.arrForEmailRightSide; track itm) {
                          <ng-option [value]="itm">{{itm}}</ng-option>
                        }
                        <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                      </ng-select>
                    }
                    @if (dataRes?.disableFax && dataRes?.emailSelected && !contactmethod) {
                      <ng-select
                        [searchable]="false" [clearable]="false" (change)="getEmailDrpDwnVal($event)" bindLabel="name"
                        [(ngModel)]="dataRes.contactEmail" bindValue="isocode" placeholder="Please select"
                        formControlName="email" class="dropdown-credit" (click)="changeColor()">
                        <ng-option disabled>Select Email Address</ng-option>
                        @for (itm of dataRes?.arrForEmailRightSide; track itm) {
                          <ng-option [value]="itm">{{itm}}</ng-option>
                        }
                        <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                      </ng-select>
                    }
                    @if (dataRes?.disableFax && !dataRes?.emailSelected && !contactmethod) {
                      <ng-select
                        [searchable]="false" [clearable]="false" (change)="getEmailDrpDwnVal($event)" bindLabel="name"
                        [(ngModel)]="dataRes.contactEmail" bindValue="isocode" placeholder="Please select"
                        formControlName="email" class="dropdown-credit" (click)="changeColor()">
                        <ng-option disabled>Select Email Address</ng-option>
                        @for (itm of dataRes?.arrForEmailRightSide; track itm) {
                          <ng-option [value]="itm">{{itm}}</ng-option>
                        }
                        <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                      </ng-select>
                    }
                    @if (dataRes?.disableFax && dataRes?.emailSelected && contactmethod) {
                      <ng-select
                        [readonly]="contactmethod" [searchable]="false" [clearable]="false"
                        (change)="getEmailDrpDwnVal($event)" bindLabel="name" [(ngModel)]="dataRes.contactEmail"
                        bindValue="isocode" placeholder="Please select" formControlName="email"
                        class="dropdown-credit disabled" (click)="changeColor()">
                        <ng-option disabled>Select Email Address</ng-option>
                        @for (itm of dataRes?.arrForEmailRightSide; track itm) {
                          <ng-option [value]="itm">{{itm}}</ng-option>
                        }
                        <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                      </ng-select>
                    }
                    @if (dataRes?.disableFax && !dataRes?.emailSelected && contactmethod) {
                      <ng-select
                        [readonly]="contactmethod" [searchable]="false" [clearable]="false"
                        (change)="getEmailDrpDwnVal($event)" bindLabel="name" [(ngModel)]="dataRes.contactEmail"
                        bindValue="isocode" placeholder="Please select" formControlName="email"
                        class="dropdown-credit disabled" (click)="changeColor()">
                        <ng-option disabled>Select Email Address</ng-option>
                        @for (itm of dataRes?.arrForEmailRightSide; track itm) {
                          <ng-option [value]="itm">{{itm}}</ng-option>
                        }
                        <ng-option [value]="addemail" id="newEmailId" class="newEmaildrpdwncls">Add new email</ng-option>
                      </ng-select>
                    }
                  </div>
                </div>
                @if (newemail) {
                  <div class="row">
                    <div class="col-sm-2 alignright">&nbsp;</div>
                    <div class="col-sm-10"><input id="contactEmail" type="email" #box (keyup)="addnewemail(box.value)" class="formElement"
                      name="addnewEmail" required>
                      @if (newEmailError) {
                        <div class="errorlabel">Please enter valid email address</div>
                      }
                    </div>
                  </div>
                }
              </div>
              @if (dataRes?.disableFax) {
                <div>
                  <label class="formLabel" for="faxcontactmethod">Fax</label>
                  <div class="row rowBtmCls">
                    <div class="col-sm-2 cotact-radio alignright">
                      @if (!dataRes?.emailSelected) {
                        <input type="radio" id="orderConfirmationNoRadio" name="orderConfirmation" value="fax" checked
                          (click)="contactmethodValchk($event)" />
                      }
                      @if (dataRes?.emailSelected) {
                        <input type="radio" id="orderConfirmationNoRadio" name="orderConfirmation" value="fax"
                          (click)="contactmethodValchk($event)" />
                      }
                    </div>
                    <div class="col-sm-10 cotact-input fax-div">@if (dataRes?.emailSelected && !contactmethod) {
                      <input #faxnumber type="text"
                        (keyup)="validateFaxNumber(faxnumber.value)" class="formElement"
                        placeholder="XXX-XXX-XXXX"
                        [(ngModel)]="dataRes.contactFax" appPhoneMask disabled id="faxcontactmethod" formControlName="fax">
                    }
                    @if (!dataRes?.emailSelected && !contactmethod) {
                      <input type="text" #faxnumber class="formElement" (keyup)="validateFaxNumber(faxnumber.value)"
                        placeholder="XXX-XXX-XXXX"
                        [(ngModel)]="dataRes.contactFax" appPhoneMask disabled id="faxcontactmethod" formControlName="fax">
                    }
                    @if (dataRes?.emailSelected && contactmethod) {
                      <input type="text" #faxnumber class="formElement" (keyup)="validateFaxNumber(faxnumber.value)"
                        placeholder="XXX-XXX-XXXX"
                        [(ngModel)]="dataRes.contactFax" appPhoneMask id="faxcontactmethod" formControlName="fax">
                    }
                    @if (!dataRes?.emailSelected && contactmethod) {
                      <input type="text" #faxnumber class="formElement" (keyup)="validateFaxNumber(faxnumber.value)"
                        placeholder="XXX-XXX-XXXX" id="faxcontactmethod"
                        [(ngModel)]="dataRes.contactFax" appPhoneMask formControlName="fax">
                    }
                    @if (faxNumberError) {
                      <div class="errorlabel">Please enter valid fax number</div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }

        <div class="formFields row basic-details__po">
          <label class="formLabel col-sm-4">Placed by</label>
          @if (!editContact) {
            <span class="readonly formlabelValue col-sm-8">{{dataRes?.placedBy}}</span>
          }
          @if (editContact) {
            <div class="w-100"></div>
          }
          @if (editContact) {
            <input type="text" disabled [value]="dataRes.placedBy" [(ngModel)]="dataRes.placedBy"
              class="formElement" formControlName="placed">
          }
        </div>

      </section>
      <section class="delivery-timings-section">

        <app-receiving-hours [fromModule]="contentModule" (EditVal)="EditValFunc($event)"
        (update)="triggerFunc($event)" [deliveryTimings]="delHrs"></app-receiving-hours>
      </section>
    </form>
  </aside>

</div>

</section>
